export default __webpack_public_path__ + "/dist/images/cuisine-icon.91c1713758333898db1a57a5ec1f395b.svg";